import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  loginServ,
  forgetPasswordServ,
  googleLoginServ
} from "../../services/authentication.services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useGlobalState } from "../../GlobalProvider";
import "./login.css";
import { Link } from "react-router-dom";
import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
function Login() {
  const { setGlobalState } = useGlobalState();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim()
        .matches(/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/, "Invalid email format")
        .required("Email is required"),
      password: Yup.string().trim().required("Password is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);
      try {
        let deviceId = localStorage.getItem("deviceId");
        const response = await loginServ({ ...values, deviceId });
        if (response?.data?.statusCode == "200") {
          toast.success(response?.data?.message);
          localStorage.setItem(
            "token",
            JSON.stringify(response?.data?.data?.token),
          );
          localStorage.setItem("user", JSON.stringify(response?.data?.data));
          localStorage.setItem(
            "permissions",
            JSON.stringify(response?.data?.data?.permissions),
          );
          setGlobalState({
            token: response?.data?.data?.token,
            user: response?.data?.data,
            permissions: response?.data?.data?.permissions,
          });
        } else {
          toast.error(response?.data?.message);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
      setSubmitting(false);
    },
  });
  const forgetPasswordFunc = async () => {
    if (!formik.values.email) {
      toast.error("Please enter your email first");
      return;
    }

    // 🛑 Invalid email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
    if (!emailRegex.test(formik.values.email)) {
      toast.error("Please enter a valid email address");
      return;
    }
    try {
      let response = await forgetPasswordServ({ email: formik.values.email });
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message);
    }
  };
  const handleAuthSuccess = (data) => {
    localStorage.setItem("token", JSON.stringify(data.token));
    localStorage.setItem("user", JSON.stringify(data));
    localStorage.setItem("permissions", JSON.stringify(data.permissions));
    setGlobalState({
      token: data.token,
      user: data,
      permissions: data.permissions,
    });
  };
  const handleGoogleSuccess = async (credentialResponse) => {
    try {
      const decoded = jwtDecode(credentialResponse.credential);
      let deviceId = localStorage.getItem("deviceId");
      const payload = {
        email: decoded.email,
        googleId: decoded.sub,
        firstName: decoded.given_name,
        lastName: decoded.family_name,
        profilePic: decoded.picture,
        deviceId: deviceId
      };

      const response = await googleLoginServ(payload);

      if (response?.data?.statusCode == "200") {
        toast.success("Logged in with Google!");
        handleAuthSuccess(response?.data?.data);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error("Google Auth Error:", error);
      toast.error("Google Login failed. Please try again.");
    }
  };
  return (
    <div className="row m-0 p-0">
      <div className="col-md-6 d-none d-md-block p-0">
        <img
          src="https://aimst.edu.my/wp-content/uploads/2020/05/online-class-video-conference.jpg"
          style={{ height: "100vh", width: "100%", objectFit: "center" }}
        />
      </div>
      <div className="col-12 col-md-6 p-0  d-flex justify-content-center align-items-center vh-100 gradientOrBg">
        <div className="signin-card">
          <img
            src="/assets/images/logo.png"
            alt="Eduverse Logo"
            className="sign-logo"
          />
          <h2>Sign In</h2>
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email Address
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  <i className="bi bi-envelope" />
                </span>
                <input
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Enter your email"
                  required=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
              </div>
              {formik.touched.email && formik.errors.email ? (
                <small
                  className="text-danger mb-2"
                  style={{ marginTop: "-20px" }}
                >
                  {formik.errors.email}
                </small>
              ) : null}
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <div className="input-group">
                <span className="input-group-text">
                  {/* <i className="bi bi-lock" /> */}
                  <i
                    class={!showPassword ? " bi bi-lock" : " bi bi-unlock"}
                    style={{ cursor: "pointer" }}
                    onClick={() => setShowPassword(showPassword)}
                  ></i>
                </span>
                <input
                  type={!showPassword ? "password" : "text"}
                  className="form-control"
                  id="password"
                  placeholder="Enter your password"
                  required=""
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.password}
                />
              </div>
              {formik.touched.password && formik.errors.password ? (
                <small
                  className="text-danger mb-2"
                  style={{ marginTop: "-20px" }}
                >
                  {formik.errors.password}
                </small>
              ) : null}
            </div>
            <div className="mb-3 text-end">
              <a
                onClick={() => forgetPasswordFunc()}
                className="forgot-password cursor"
              >
                Forgot Password?
              </a>
            </div>

            <button
              type="submit"
              className="btn btn-gradient"
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {formik.isSubmitting ? "Secure Login ..." : "Login"}
            </button>
          </form>
          <div>
            <p
              className="text-center text-muted mb-0 mt-3"
              style={{ fontSize: "12px" }}
            >
              Or
            </p>
            <div className="d-flex align-items-center justify-content-center mt-3">
              {/* <img style={{height:"20px",}} src="https://cdn-icons-png.flaticon.com/128/281/281764.png"/>
              <p className="mb-0 ms-3"><u>Login with Google</u></p> */}
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={() => toast.error("Login Failed")}
                useOneTap
                shape="pill"
                theme="outline"
              />
            </div>
          </div>
          <div
            className="mt-4 text-center text-muted"
            style={{ fontSize: "12px" }}
          >
            Don't have an account?{" "}
            <Link to="/signup" className="forgot-password cursor text-info ">
              <u>Register</u>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    <div className="signin-container">
      <div className="signin-card">
        <img
          src="/assets/images/logo.png"
          alt="Eduverse Logo"
          className="sign-logo"
        />
        <h2>Sign In</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email Address
            </label>
            <div className="input-group">
              <span className="input-group-text">
                <i className="bi bi-envelope" />
              </span>
              <input
                type="email"
                className="form-control"
                id="email"
                placeholder="Enter your email"
                required=""
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.email}
              />
            </div>
            {formik.touched.email && formik.errors.email ? (
              <small
                className="text-danger mb-2"
                style={{ marginTop: "-20px" }}
              >
                {formik.errors.email}
              </small>
            ) : null}
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">
              Password
            </label>
            <div className="input-group">
              <span className="input-group-text">
                {/* <i className="bi bi-lock" /> */}
                <i
                  class={!showPassword ? " bi bi-lock" : " bi bi-unlock"}
                  style={{ cursor: "pointer" }}
                  onClick={() => setShowPassword(showPassword)}
                ></i>
              </span>
              <input
                type={!showPassword ? "password" : "text"}
                className="form-control"
                id="password"
                placeholder="Enter your password"
                required=""
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
            </div>
            {formik.touched.password && formik.errors.password ? (
              <small
                className="text-danger mb-2"
                style={{ marginTop: "-20px" }}
              >
                {formik.errors.password}
              </small>
            ) : null}
          </div>
          <div className="mb-3 text-end">
            <a
              onClick={() => forgetPasswordFunc()}
              className="forgot-password cursor"
            >
              Forgot Password?
            </a>
          </div>

          <button
            type="submit"
            className="btn btn-gradient"
            disabled={formik.isSubmitting || !formik.isValid}
          >
            {formik.isSubmitting ? "Secure Login ..." : "Login"}
          </button>
        </form>
        <div className="mt-4 text-center">
          Don't have an account?{" "}
          <Link to="/signup" className="forgot-password cursor text-info ">
            <u>Register</u>
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Login;
